import { Injectable } from '@angular/core';
import { LocationChangeListener, LocationStrategy } from '@angular/common';

@Injectable()
export class NullLocationStrategy extends LocationStrategy {
  back(): void {}

  forward(): void {}

  getBaseHref(): string {
    return '';
  }

  getState(): unknown {
    return undefined;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onPopState(fn: LocationChangeListener): void {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  path(includeHash?: boolean): string {
    return '/';
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  prepareExternalUrl(internal: string): string {
    return internal;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  pushState(state: unknown, title: string, url: string, queryParams: string): void {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  replaceState(state: unknown, title: string, url: string, queryParams: string): void {}
}
